import React, { useEffect, useRef, useState } from "react";
import * as THREE from "three";
import { Canvas, useFrame, useThree } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";

const globeRadius = 100;
const globeWidth = 4098 / 2;
const globeHeight = 1968 / 2;

function convertFlatCoordsToSphereCoords(x, y) {
  let latitude = ((x - globeWidth) / globeWidth) * -180;
  let longitude = ((y - globeHeight) / globeHeight) * -90;
  latitude = (latitude * Math.PI) / 180;
  longitude = (longitude * Math.PI) / 180;
  const radius = Math.cos(longitude) * globeRadius;

  return {
    x: Math.cos(latitude) * radius,
    y: Math.sin(longitude) * globeRadius,
    z: Math.sin(latitude) * radius,
  };
}

function GlobePoints({ points }) {
  const groupRef = useRef();

  // Rotate the group slowly
  useFrame(() => {
    if (groupRef.current) {
      groupRef.current.rotation.y += 0.002;
    }
  });

  const pointGeometry = new THREE.SphereGeometry(0.5, 6, 6);
  const pointMaterial = new THREE.MeshBasicMaterial({ color: "#a1a1aa" });

  const meshes = points.map((point, index) => {
    const { x, y, z } = convertFlatCoordsToSphereCoords(point.x, point.y);
    if (!x && !y && !z) return null;

    return (
      <mesh
        key={index}
        geometry={pointGeometry}
        material={pointMaterial}
        position={[x, y, z]}
      />
    );
  });

  return <group ref={groupRef}>{meshes}</group>;
}

function GlobeScene({ points }) {
  const { camera } = useThree();
  useEffect(() => {
    camera.position.z = -265;
  }, [camera]);

  return (
    <>
      <OrbitControls
        enableZoom={false}
        enablePan={false}
        enableDamping={false}
        autoRotate
        autoRotateSpeed={1.0}
      />
      <ambientLight intensity={0.5} />
      <GlobePoints points={points} />
    </>
  );
}

export default function Globe() {
  const [points, setPoints] = useState([]);

  useEffect(() => {
    fetch(
      "https://raw.githubusercontent.com/creativetimofficial/public-assets/master/soft-ui-dashboard-pro/assets/js/points.json"
    )
      .then((response) => response.json())
      .then((data) => {
        setPoints(data.points);
      });
  }, []);

  return (
    <div
      style={{
        width: "100%",
        height: "138px",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "800px",
          top: "-185px",
          position: "relative",
        }}
      >
        <Canvas
          style={{
            position: "absolute",
            bottom: "0",
            height: "100%",
            width: "100%",
          }}
        >
          {points.length > 0 && <GlobeScene points={points} />}
        </Canvas>
      </div>
    </div>
  );
}
